import React, { useEffect } from 'react';

const Hotjar = () => {
  useEffect(() => {
    const hotjarScript = document.createElement('script');
    hotjarScript.innerHTML = `
      (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={
        hjid:window.location.href.startsWith("https://app.testsigma.com") ? 2947348 : 2941736,
        hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    document.body.appendChild(hotjarScript);
  }, []);

  return <></>;
};

export default Hotjar;
